An optional hirer-provided free-text job reference. In the syncPosition flow, this is mapped to the seekPartnerPositionId field.
